// extracted by mini-css-extract-plugin
export default {"cardStyle":"DeveloperCard_cardStyle__khnTZ","imgStyle":"DeveloperCard_imgStyle__6Ejii","buttonRow":"DeveloperCard_buttonRow__bCEF4"};